import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import * as CustomToast from '../components/CustomToastMessage';

function ImageUpload({ onFileSelect, onDelete, images = [], multiple = false }) {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter(file => {
            if (!file.type.startsWith('image/')) {
                CustomToast.error('Please select an image file');
                return false;
            }
            return true;
        });

        if (validFiles.length > 0 && onFileSelect) {
            onFileSelect(validFiles);
        }
        // Reset the input value to allow selecting the same file again
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleDeleteClick = (index) => {
        if (onDelete) {
            onDelete(index);
        }
    };

    const handleUploadClick = (e) => {
        e.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // In single-file mode, only show the first image.
    const imagesToShow = multiple ? images : images.slice(0, 1);

    return (
        <>
            <div className="d-flex flex-wrap gap-3">
                {imagesToShow.map((image, index) => (
                    <div key={image.url || index} className="text-center image-preview d-flex justify-content-center align-items-center position-relative" style={{ width: '150px', height: '150px' }}>
                        <div className="rounded-3 overflow-hidden h-100 w-100">
                            <img
                                src={image.url}
                                alt="Uploaded"
                                className="w-100 h-100 object-fit-cover"
                            />
                        </div>
                        <div className="d-flex align-items-center gap-3 position-absolute top-0 end-0 m-1">
                            <img
                                src="/images/png/img-delete.png"
                                className="pointer"
                                width={30}
                                height={30}
                                onClick={() => handleDeleteClick(index)}
                                alt="Delete Icon"
                            />
                        </div>
                    </div>
                ))}
                {/* Show upload button if multiple is enabled, or if it's single mode and no image is present */}
                {(multiple || images.length === 0) && (
                    <Form.Label className="images-upload d-flex justify-content-center align-items-center" style={{ width: '150px', height: '150px' }} onClick={handleUploadClick}>
                        <div>
                            <img
                                className="d-flex justify-content-center m-auto"
                                src="/images/png/upload.png"
                                width={40}
                                height={40}
                                alt="Upload Icon"
                            />
                            <span>Select your file</span>
                        </div>
                    </Form.Label>
                )}
                <Form.Control
                    ref={fileInputRef}
                    className="d-none"
                    type="file"
                    accept='image/png, image/jpeg, image/jpg'
                    onChange={handleFileChange}
                    multiple={multiple}
                />
            </div>
        </>
    );
}

export default ImageUpload;
